module.exports = __webpack_public_path__ + "img/menu.754f447d.svg";